import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  width: 136px;
  padding: 24px 16px 0 16px;
  justify-content: space-between;
  background: #ffffff;
`;

const Count = styled.input`
  height: 32px;
  width: 32px;
  font-size: 16px;
  font-weight: 600;
  color: #212124;
  border: none;
  text-align: center;
  padding: 0;
  outline: none;
  user-select: text;
  background: transparent;
`;

const Button = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const MinusIcon = styled.span`
  background: #000;
  height: 1.5px;
  width: 17.5px;
`;

const PlusIcon = styled.span`
  position: relative;
  width: 17.5px;
  height: 17.5px;

  &:before,
  &:after {
    content: '';
    position: absolute;
    background-color: #212124;
  }

  /* Vertical line */
  &:before {
    top: 0;
    left: 50%;
    width: 1.5px;
    height: 100%;
    margin-left: -0.75px;
  }

  /* horizontal line */
  &:after {
    top: 50%;
    left: 0;
    width: 100%;
    height: 1.5px;
    margin-top: -0.75px;
  }
`;

type Props = {
  /**
   * setQuantity
   */
  setQuantity: (quantity: string) => void;
  /**
   * quantity
   */
  quantity: string;
};

/**
 * Quantity
 */
const Quantity = ({ setQuantity, quantity }: Props) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement> | null, action?: number) => {
    const value = event?.target?.value || action;
    if (!value) {
      return;
    }
    const quantityInt: number = parseInt(quantity, 10);
    let newValue = '1';

    if (typeof value === 'string') {
      newValue = value.replace(/\D/g, '');
      if (newValue[0] === '0') {
        newValue = newValue.substr(1);
      }
    } else if (quantityInt + value > 0) {
      newValue = (quantityInt + value).toString();
    }

    setQuantity(newValue.toString());
  };

  return (
    <Wrapper>
      <Button onClick={() => handleChange(null, -1)}>
        <MinusIcon />
      </Button>
      <Count type="text" onChange={handleChange} value={quantity.toString()} />
      <Button onClick={() => handleChange(null, 1)}>
        <PlusIcon />
      </Button>
    </Wrapper>
  );
};

export default Quantity;
